import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

import AgencyOwnerDashboard from "./Agency/AgencyOwnerDashboard";
import AgencyStaffDashboard from "./Agency/AgencyStaffDashboard";
import SuperAdminDashboard from "./Admin/SuperAdminDashboard";
import InternalDashboard from "./Admin/InternalDashboard";
import { ROLES } from "../../constants/roles";

export default function DashboardRouter() {
  const { user } = useAuth();

  if (!user) return <Navigate to="/" replace />;

  switch (user.role) {
    case ROLES.AGENCY_OWNER:
      return <AgencyOwnerDashboard />;
    case ROLES.AGENCY_STAFF:
      return <AgencyStaffDashboard />;
    case ROLES.SUPER_ADMIN:
      return <SuperAdminDashboard />;
    case ROLES.SALES_ACCOUNT_SPECIALIST:
    case ROLES.HELPDESK:
    case ROLES.TECHNICAL_SUPPORT_SPECIALIST:
      return <InternalDashboard />;
    default:
      return <div>Unauthorized role: {user.role}</div>;
  }
}
